import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import HowItWorks from './components/HowItWorks';
import WhySpecial from './components/WhySpecial';
import Occasions from './components/Occasions';
import TreeOptions from './components/TreeOptions';
import Pricing from './components/Pricing';
import Storytelling from './components/Storytelling';
import Founders from './components/Founders';
import Trust from './components/Trust';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import GiftDialog from './components/GiftDialog';
import WhatsAppButton from './components/WhatsAppButton';
import FoundersPage from './pages/FoundersPage';
import AdminPage from './pages/AdminPage';
import GardenPage from './pages/GardenPage';
import AuthCallback from './pages/AuthCallback';
import { AuthProvider } from './lib/auth';
import { Toaster } from './components/ui/sonner';

function Home() {
  const [open, setOpen] = React.useState(false);
  const [selectedTree, setSelectedTree] = React.useState(null);
  const [selectedPlan, setSelectedPlan] = React.useState(null);

  const openGift = () => { setSelectedPlan(null); setSelectedTree(null); setOpen(true); };
  const openGiftWithTree = (key) => { setSelectedTree(key); setSelectedPlan(null); setOpen(true); };
  const openGiftWithPlan = (key) => { setSelectedPlan(key); setSelectedTree(null); setOpen(true); };

  return (
    <>
      <Navbar onGift={openGift} />
      <Hero onGift={openGift} />
      <About />
      <HowItWorks />
      <WhySpecial />
      <TreeOptions onGift={openGift} onSelect={openGiftWithTree} />
      <Pricing onSelectPlan={openGiftWithPlan} />
      <Storytelling />
      <Founders />
      <Occasions onGift={openGift} />
      <Trust />
      <Testimonials />
      <CTASection onGift={openGift} />
      <Footer />
      <GiftDialog open={open} onOpenChange={setOpen} defaultTree={selectedTree} defaultPlan={selectedPlan} />
      <WhatsAppButton />
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  // Catch Emergent Auth hash redirects arriving at ANY route — they land with
  // `#session_id=...` on the original pre-login path. Route them to AuthCallback
  // BEFORE normal route rendering.
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/founders" element={<FoundersPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/garden" element={<GardenPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="App bg-brand-bg text-brand-ink min-h-screen">
          <AppRouter />
          <Toaster />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
